import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-flexbox-grid'

// hixme-ui
import { Label, FormGroup } from '@hixme-ui/forms'

import { FieldInput } from 'components/ReduxFormComponents'
import locations from 'modules/locations'

const { LocationsContainer } = locations.containers
const RenderMailingZipAndLocations = ({
  MailingPostalCode,
  MailingCounty,
  disabled,
  action = 'add',
}) => {
  // Use different form name for editing
  const actualFormName = action === 'edit' ? 'editEmployee' : 'addEmployee'

  return (
    <Row>
      <Col xs={4}>
        <FormGroup>
          <Label medium thin>
            Zip code
          </Label>
          <FieldInput
            {...MailingPostalCode}
            disabled={disabled}
            onChange={(e) => {
              MailingPostalCode.input.onChange(e)
              MailingCounty.input.onChange('')
            }}
          />
        </FormGroup>
      </Col>
      <Col xs={4}>
        <FormGroup>
          <Label medium thin>
            County, State
          </Label>
          <LocationsContainer
            {...MailingCounty.input}
            postalCode={MailingPostalCode.input.value}
            disabled={
              disabled ||
              (MailingPostalCode.meta.touched && MailingPostalCode.meta.invalid)
            }
            formName={actualFormName}
            fieldName="MailingCounty"
            meta={MailingCounty.meta}
          />
        </FormGroup>
      </Col>
    </Row>
  )
}

RenderMailingZipAndLocations.propTypes = {
  MailingPostalCode: PropTypes.object,
  MailingCounty: PropTypes.object,
  disabled: PropTypes.bool,
  formName: PropTypes.string,
  action: PropTypes.string,
}

RenderMailingZipAndLocations.defaultProps = {
  MailingPostalCode: {},
  MailingCounty: {},
  disabled: false,
}

export default RenderMailingZipAndLocations
